import { render, staticRenderFns } from "./ItemUpload.vue?vue&type=template&id=0dc8b856&"
import script from "./ItemUpload.vue?vue&type=script&lang=js&"
export * from "./ItemUpload.vue?vue&type=script&lang=js&"
import style0 from "./ItemUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports